import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fin-section-review',
  templateUrl: 'section-review.component.html',
  styleUrls: ['section-review.component.scss'],
  standalone: false,
})
export class SectionReviewComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  fullWidth = false;

  @Input()
  endTitle: string;

  @Input()
  noContent: boolean;

  @Input()
  showPaddingBottom?: boolean;

  @Input()
  noButton: boolean;

  @Input()
  endTitleClasses: string;

  @Input()
  showHighlightedContent = false;

  @Input()
  roundedBottom = true;

  @Input()
  hasBorder = true;

  shouldShowSmallPadding = false;

  ngOnInit(): void {
    this.shouldShowSmallPadding = this.showPaddingBottom ?? (!this.fullWidth && !this.noContent);
  }
}
